module.exports = __webpack_public_path__ + "static/img/drivethru.d35c67b.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/collectibles/drivethru.gif
// module id = 4qJu
// module chunks = 1